export const TeamState = {
  teams: [],
}
